<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Warehouse Stock </h4>
					<!-- <button class="float-right btn btn-primary shadow mt-2" v-on:click="formWarehouse=!formWarehouse">
						Tambah Warehouse baru
					</button> -->
				</div>
				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :datas="locations" :structure="tableStructure"
					           :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-seeker seeker-url="/api/master/seeker/troubleshoot-location"
					           @refetch="(row)=>{rowLimit=row;getWarehouse()}"
					           @searching="(val)=>!val.status?getWarehouse():locations=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Location:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.warehouse_name }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 mt-2 pt-0">
											<b-button v-b-modal.modal-edit-location class="btn btn-info mr-2"
											          v-on:click="selectedWarehouse=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="eye"></b-icon>
											</b-button>

										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.warehouse_name }}</td>
							<td v-if="!isMobile">
								<b-button title="Detail" v-b-modal.modal-edit-location class="btn btn-info mr-2"
								          v-on:click="selectedWarehouse=index;dataEdit=Object.assign({},obj);getProduct()">
									<b-icon icon="eye"></b-icon>
								</b-button>
								<b-button title="Detail" v-b-modal.modal-transfer-location class="btn btn-info mr-2"
								          v-on:click="selectedWarehouse=index;dataEdit=Object.assign({},obj);getTransfer()">
									<b-icon icon="forward"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>
				<b-modal no-close-on-esc content-class="m-0" id="modal-edit-location" title="Transfer Stock" scrollable
				         no-close-on-backdrop size="lg" @hide="editModalClose">
					<b-container fluid v-if="!loadData&&locations.length>0">
						<b-row class="mt-3 pt-1" v-if="locations[selectedWarehouse]!=undefined">
							<b-col cols="12" class="my-1">
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Location </label>
								<p>{{locations[selectedWarehouse].warehouse_name}}</p>
							</b-col>
							<b-col cols="12" md="12" lg="12">
								<datatable :currentIdx="currentPageProduct" :datas="dataProduct" :structure="tableStructureProduct"
							           :init="loadDataProduct"
							           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePageProduct(isNext)}"
							           use-seeker seeker-url="/api/inventaris/warehouse-item"
							           @refetch="(row)=>{rowLimit=row;getProduct()}"
							           @searching="(val)=>!val.status?getProduct():dataProduct=val.data">
								<template #customcell={obj,index}>
									<td v-if="isMobile" class="py-3">
										<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
											<li class="mt-2">
												<div class="text-left mx-3 pt-0">
													<small class="my-0 py-0">Location:</small>
													<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.warehouse_name }}</b>
												</div>
												<hr class="my-1">
											</li>
											<li class="mt-2">
												<div class="text-left mx-3 mt-2 pt-0">
													<b-button v-b-modal.modal-edit-location class="btn btn-info mr-2"
													          v-on:click="selectedWarehouse=index;dataEdit=Object.assign({},obj)">
														<b-icon icon="forward"></b-icon>
													</b-button>

												</div>
											</li>
										</ul>
									</td>
									<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
									<td v-if="!isMobile">{{ obj.hardware_name }}</td>
									<td v-if="!isMobile">{{ obj.po_item }}</td>
									<td v-if="!isMobile">{{ obj.total }}</td>
								</template>
							</datatable>
							</b-col>
							<b-col cols="12" class="my-3 text-right" v-if="updateState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="updateSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil update data warehouse.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="errorSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal update data warehouse.
									</div>
								</div>
							</div>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary mr-2"
							          @click="(!updateState)?$bvModal.hide('modal-edit-location'):''">Tutup
							</b-button>
						</div>
					</template>
				</b-modal>
				<b-modal no-close-on-esc content-class="m-0" id="modal-transfer-location" title="Transfer Stock" scrollable
				         no-close-on-backdrop size="lg" @hide="editModalClose">
					<b-container fluid v-if="!loadData&&locations.length>0">
						<b-row class="mt-3 pt-1" v-if="locations[selectedWarehouse]!=undefined">
							<b-col cols="12" class="my-1">
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Location </label>
								<p>{{locations[selectedWarehouse].warehouse_name}}</p>
							</b-col>
		                  	<div class="col-12 col-md-6 col-lg-4 mt-2">
			                    <label class="d-block">Transfer To</label>
			                    <smart-search 
			                    :search-value="newTransferStock.label_warehouse" init url="/api/master/seeker/warehouse" usedefault :default-value="newTransferStock.label_warehouse" key-tag="warehouse_name" v-on:update="(data)=>{newTransferStock.id_warehouse=data.id}"  @update-direct="(label)=>newTransferStock.label_warehouse=label"></smart-search>
		                  	</div>
							<div class="col-12 mt-2">
		                    <br>
		                    <b>List item:</b>
		                    <hr>
		                    <div class="row py-2" style="background:#f0f0f0" v-for="(item,index) in newTransferStock.items" v-bind:key="'newitem'+item.id">
		                      <div class="col-12">
		                        <button class="float-right btn btn-sm btn-danger bg-white" @click="newTransferStock.items.splice(index, 1);">hapus</button>
		                      </div>
		                      <div class="col-12 col-md-4">
		                        <label class="d-block">Item</label>
		                        <smart-search init :url="seekerUrlProduct(item)" :label-tag="['po_item']" key-tag="po_item" v-on:update="(data)=>{item.po_item=data.po_item;item.item_id=data.item_id}" :search-value="item.po_item" @update-direct="(label)=>item.po_item=label"></smart-search>
		                      </div>
		                    </div>
		                  </div>
		                  <div class="col-12 mt-3">
		                    <button class="float-right btn btn-secondary" @click="newTransferStock.items.push({item_id:-1,po_item:''})">tambah</button>
		                  </div>
							<b-col cols="12" class="my-3 text-right" v-if="updateState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="updateSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil update data warehouse.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="errorSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal update data warehouse.
									</div>
								</div>
							</div>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary mr-2"
							          @click="(!updateState)?$bvModal.hide('modal-transfer-location'):''">Tutup
							</b-button>
							<button class="btn btn-info" v-on:click="updateData">submit</button>
						</div>
					</template>
				</b-modal>
				<modal-delete url="/api/master/warehouse/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					Yakin mau menghapus data dengan detail berikut :<br>
					<ul>
						<li>Lokasi: {{ itemToDelete.warehouse_name }}</li>
					</ul>
				</modal-delete>
			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			currentPageProduct: 1,
			perPage: null,
			perPageProduct: null,
			rowLimit: 10,
			nextUrl: null,
			nextUrlProduct: null,
			prevUrl: null,
			prevUrlProduct: null,
			isMobile: false,
			//step 1 edit
			dataEdit: null,
			deleteId: 0,
			createErrorMessage: "Gagal Menyimpan Location  Baru.",
			errorMessages: [],
			itemToDelete: {},
			locations: [],
			dataProduct:[],
			searchValue: "",
			loadData: true,
			loadDataProduct: true,
			savingNew: false,
			errorNew: false,
			errorList: [],
			errorSaved: false,
			existingClientResult: [],
			newSaved: false,
			updateState: false,
			updateSaved: false,
			updateUserState: false,
			selectedWarehouse: 0,
			selectedTab: 0,
			updateClientCol: 6,
			newWarehouse: {
				warehouse_name: ""
			},
            newTransferStock:{
            	id_warehouse:'',
            	label_warehouse:'',
              	items:[
                	{item_id:-1,po_item:'',price:0}
              	],
          	},
			formWarehouse: false,
			tableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "Warehouse", key: null},
				{label: "Tindakan", key: null}
			],
			tableStructureProduct: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "Name", key: null},
				{label: "Type", key: null},
				{label: "Total", key: null}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("hardware type page");
		this.getWarehouse();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.locations = newData;
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/warehouse?limit=" + this.rowLimit + "&page=" + myParams;
			this.getWarehouse(newUrl);
		},
		changePageProduct(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/warehouse?limit=" + this.rowLimit + "&page=" + myParams;
			this.getWarehouse(newUrl);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getWarehouse();
			}
		},
		seekerUrlProduct(item)
		{
			return "/api/inventaris/warehouse-itemdetail?warehouse_id="+this.locations[this.selectedWarehouse].id+'&type=no';
		},
		getWarehouse(url = (this.$baseUrl + "/api/master/warehouse?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.locations = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		getProduct(url = (this.$baseUrl + "/api/inventaris/warehouse-item?limit=" + this.rowLimit)) {
			this.loadDataProduct = true;
			url+= '&warehouse_id='+this.locations[this.selectedWarehouse].id;
			url+= '&type=no';
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrlProduct = result.prev_page_url;
				this.nextUrlProduct = result.next_page_url;
				this.currentPageProduct = result.current_page;
				this.perPageProduct = parseInt(result.per_page);
				this.dataProduct = result.data;
				console.log(this.dataProduct);
				this.loadDataProduct = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadDataProduct = false;
			});
		},
		getTransfer(){
			this.newTransferStock = {
            	id_warehouse:'',
            	label_warehouse:'',
              	items:[
                	{item_id:-1,po_item:'',price:0}
              	],
          	};
		},
		newUsernameChange() {
			this.newWarehouse.password = this.newWarehouse.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk lokasi id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newWarehouse.role = newValue;
		},
		setNewClientId(newId) {
			this.newWarehouse.clientId = newId;
			console.log(this.newWarehouse.clientId);
		},
		updateData(){
			console.log(this.newTransferStock);
			axios.post(
				this.$baseUrl + "/api/master/warehouse-transfer",
				this.newTransferStock,
				{
					"headers":
						{
							"Authorization": "Bearer " + localStorage.getItem("accessToken")
						}
				}
			).then((result) => {
				if (result.status == 200) {
					this.updateState = false;
					this.updateSaved = true;
					//step 4 edit
					this.dataEdit = this.locations[this.selectedWarehouse];
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-transfer-location");
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.errorList = [];
				this.errorList = Object.values(err.response.data.errors);
				console.log(this.errorList);
				this.errorNew = true;
				this.savingNew = false;
			});
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.locations, this.selectedWarehouse, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updateState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-location");
			}
		},
		deleteModalClose(mdl) {
			if (this.deleteLocationState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-location");
			}
		},

		deleteClientData() {
			console.log("deleting data");
			this.deleteLocationState = true;
			axios.delete(
				this.$baseUrl + "/api/master/warehouse/" + this.locations[this.selectedToDelete].id,
				{
					"headers": {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status == 200) {
					this.deleteLocationState = false;
					this.locationDeleted = true;
					this.locations.splice(this.selectedToDelete, 1);

					setTimeout(() => {
						this.$bvModal.hide("modal-delete-location");
						this.locationDeleted = false;
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteLocationState = false;
				this.failDeleteUser = true;
				setTimeout(() => {
					this.failDeleteUser = false;
				}, 1000);
				console.log(err);
			});
		}
	}
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}

::v-deep .modal-content {
	margin: -3.25rem auto;
}
</style>
